export interface Address {
  addressLine1: string
  addressLine2: string
  city: string
  state: string
  country: string
  zipcode: string
}

export const UIProviders_DISABLED = {
  DISABLED: true,
  ENABLED: false,
}
export const UIProviders_HIDDEN = {
  HIDDEN: true,
  VISIBLE: false,
}

export const UIProviders_REQUIRED = {
  REQUIRED: true,
  NOT_REQUIRED: false,
}

export interface DefaultModelProperty<T> {
  type: string
  name: T
  defaultName: string
}
export interface LabelValue<T> {
  label: string
  value: T
}
export enum LinkType {
  AccountStatus = 'AccountStatus',
  ApprovalRequestLogType = 'ApprovalRequestLogType',
  ApprovalRequestStatus = 'ApprovalRequestStatus',
  ApprovalRequestType = 'ApprovalRequestType',
  BerryLayout = 'BerryLayout',
  BrandingResourceType = 'BrandingResourceType',
  BrandingResponses = 'BrandingResponses',
  Browser = 'Browser',
  Browsers = 'Browsers',
  ContentHouseState = 'ContentHouseState',
  DeviceSettingTypes = 'DeviceSettingTypes',
  DeviceType = 'DeviceType',
  EnableStatus = 'EnableStatus',
  ExpressedPreferenceType = 'ExpressedPreferenceType',
  FeedbackCategory = 'FeedbackCategory',
  FlagState = 'FlagState',
  FlagType = 'FlagType',
  GameMetricType = 'GameMetricType',
  Gender = 'Gender',
  GroupType = 'GroupType',
  IssueState = 'IssueState',
  IssueType = 'IssueType',
  Language = 'Language',
  LogLevel = 'LogLevel',
  LogType = 'LogType',
  MarketMetricType = 'MarketMetricType',
  MarketResourceType = 'MarketResourceType',
  MediaFormatQuality = 'MediaFormatQuality',
  MediaStatisticType = 'MediaStatisticType',
  MediaStatus = 'MediaStatus',
  MediationStepType = 'MediationStepType',
  MediaType = 'MediaType',
  MetricStep = 'MetricStep',
  Mobile = 'Mobile',
  NotificationStatus = 'NotificationStatus',
  OperatingSystems = 'OperatingSystems',
  OwnerType = 'OwnerType',
  PaymentMethodTypes = 'PaymentMethodTypes',
  PendingBrandingStatus = 'PendingBrandingStatus',
  PendingMediaCustomizationStates = 'PendingMediaCustomizationStates',
  Platform = 'Platform',
  PlayerAccountPermissions = 'PlayerAccountPermissions',
  PlayerContentCreatorPermissions = 'PlayerContentCreatorPermissions',
  PlayerMarketingPermissions = 'PlayerMarketingPermissions',
  PlayerMediaPermissions = 'PlayerMediaPermissions',
  PlayerMediationPermissions = 'PlayerMediationPermissions',
  PlayerPermission = 'PlayerPermission',
  PlayerReleasePermissions = 'PlayerReleasePermissions',
  PlayerSystemPermissions = 'PlayerSystemPermissions',
  PlayerUserPermissions = 'PlayerUserPermissions',
  PlaywatchSetting = 'PlaywatchSetting',
  ProcessJobState = 'ProcessJobState',
  ProfilePermissions = 'ProfilePermissions',
  ProfileStatusType = 'ProfileStatusType',
  PublishingState = 'PublishingState',
  Rating = 'Rating',
  RawMetricKeys = 'RawMetricKeys',
  ReactionTypes = 'ReactionTypes',
  ReleaseActionType = 'ReleaseActionType',
  ReleaseState = 'ReleaseState',
  ReleaseType = 'ReleaseType',
  ResourcePropertyType = 'ResourcePropertyType',
  RestrictionType = 'RestrictionType',
  SocialMediaType = 'SocialMediaType',
  StatType = 'StatType',
  SystemSetings = 'SystemSetings',
  SystemSettingTypes = 'SystemSettingTypes',
  TagType = 'TagType',
  Views = 'Views',
  ViewType = 'ViewType',
}
export enum ComponentUITypes {
  DROPDOWN = 'DROPDOWN',
  BUTTON = 'BUTTON',
  PHONENUMBER = 'PHONENUMBER',
  AGE = 'AGE',
  CAR_MAKE = 'CAR_MAKE',
  CAR_YEAR = 'CAR_YEAR',
  CAR_MODEL = 'CAR_MODEL',
  MARITAL_STATUS = 'MARITAL_STATUS',
  LIST = 'LIST',
  SSN = 'SSN',
  CHECKBOX = 'CHECKBOX',
  STATE_PROVINCE = 'STATE_PROVINCE',
  DATETIME = 'DATETIME',
  NUMBER = 'NUMBER',
  INT = 'INT',
  STRING = 'STRING',
  ADDRESS = 'ADDRESS',
  CHECKBOXFIELD = 'CHECKBOXFIELD',
  TEXTAREA = 'TEXTAREA',
}
export enum UIProviders {
  DISABLED = 'disabled',
  REQUIRED = 'required',
  HIDDEN = 'hidden',
  VALUE = 'value',
}
